/* Mapa de calor del Almacen de Navidad (Alas Coral) - 13 oct 2026.
   Solo mide; no cambia nada del almacen. Manda en lotes al mismo script de los pedidos (data-url de #almacen-navidad):
   toques en el mundo (coordenadas del mundo), posicion cada 3 s, fichas abiertas y compras (lo que ya manda el pixel),
   botones (Ver como lista, carrito, chips) y la salida. Sin datos personales. */
(function () {
  if (window.__navMapa) return; window.__navMapa = 1;
  var raiz = document.getElementById('almacen-navidad');
  var URL_ = raiz && raiz.dataset ? raiz.dataset.url : '';
  if (!URL_) return;
  var sid = Math.random().toString(36).slice(2, 10) + Date.now().toString(36).slice(-4);
  var t0 = Date.now(), q = [];
  var qs = new URLSearchParams(location.search);
  var fuente = qs.get('utm_source') || (qs.get('fbclid') ? 'facebook' : '');
  if (!fuente) { try { fuente = document.referrer ? new URL(document.referrer).hostname : 'directo'; } catch (e) { fuente = 'directo'; } }
  var anuncio = qs.get('utm_content') || qs.get('utm_campaign') || qs.get('ad_id') || '';
  var disp = innerWidth < 520 ? 'movil' : innerWidth < 1000 ? 'tablet' : 'pc';

  function camara() {
    var m = document.getElementById('mundo'); var tr = m && m.style.transform || '';
    var r = tr.match(/translate\((-?[\d.]+)px,\s*(-?[\d.]+)px\)\s*scale\(([\d.]+)\)/);
    return r ? { cx: -parseFloat(r[1]), cy: -parseFloat(r[2]), s: parseFloat(r[3]) } : null;
  }
  function aMundo(x, y) { var c = camara(); if (!c || !c.s) return null; return { x: Math.round((x + c.cx) / c.s), y: Math.round((y + c.cy) / c.s) }; }
  function ev(tipo, x, y, dato) {
    q.push([Date.now() - t0, tipo, x == null ? '' : x, y == null ? '' : y, String(dato == null ? '' : dato).slice(0, 80)]);
    if (q.length >= 30) enviar();
  }
  function enviar(fin) {
    if (!q.length) return;
    var body = JSON.stringify({ tipo: 'nav_mapa', s: sid, d: disp, f: fuente, a: anuncio, w: innerWidth, h: innerHeight, ev: q.splice(0, 60) });
    try {
      if (fin && navigator.sendBeacon) navigator.sendBeacon(URL_, new Blob([body], { type: 'text/plain' }));
      else fetch(URL_, { method: 'POST', body: body, mode: 'no-cors', keepalive: true });
    } catch (e) {}
  }
  function nombreDe(el) {
    if (!el) return '';
    var a = el.getAttribute('aria-label'); if (a) return a.split(',')[0];
    var b = el.querySelector('b'); return b ? b.textContent : (el.textContent || '').trim().slice(0, 40);
  }

  ev('inicio', null, null, disp + ' ' + innerWidth + 'x' + innerHeight);

  document.addEventListener('pointerdown', function (e) {
    if (!e.target || !e.target.closest || !e.target.closest('#vista')) return;
    var p = aMundo(e.clientX, e.clientY);
    var obj = e.target.closest('.vitrina,.cartel');
    ev(obj ? (obj.classList.contains('cartel') ? 'toque_cartel' : 'toque_juguete') : 'toque', p && p.x, p && p.y, obj ? nombreDe(obj) : '');
  }, true);

  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('#listaBtn,#carritoBtn,#chips button,.hoja button,.hoja a,.hoja [data-k]');
    if (!b) return;
    var zona = b.id ? b.id : b.closest('#chips') ? 'chip' : 'hoja';
    ev('boton', null, null, (zona + ': ' + (b.textContent || b.getAttribute('aria-label') || '').trim()).slice(0, 70));
  }, true);

  var ultPos = '';
  setInterval(function () {
    if (document.hidden || document.querySelector('.velo')) return;
    var p = aMundo(innerWidth / 2, innerHeight / 2); if (!p) return;
    var k = Math.round(p.x / 60) + ',' + Math.round(p.y / 60);
    if (k !== ultPos) { ultPos = k; ev('pos', p.x, p.y, ''); }
  }, 3000);

  function envolver() {
    var o = window.fbq; if (!o) return false; if (o.__nm) return true;
    var w = function () {
      try {
        if (arguments[0] === 'track') {
          var d = arguments[2] || {};
          ev('px_' + arguments[1], null, null, (d.content_ids || []).join('|') + (d.value ? ' $' + d.value : ''));
          if (arguments[1] === 'Purchase' || arguments[1] === 'InitiateCheckout') enviar();
        }
      } catch (e) {}
      return o.apply(this, arguments);
    };
    for (var k in o) { try { w[k] = o[k]; } catch (e) {} }
    w.__nm = 1; window.fbq = w; return true;
  }
  if (!envolver()) { var n = 0, ti = setInterval(function () { if (envolver() || ++n > 40) clearInterval(ti); }, 500); }

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) { ev('oculta', null, null, Math.round((Date.now() - t0) / 1000) + 's'); enviar(true); }
    else ev('vuelve', null, null, '');
  });
  addEventListener('pagehide', function () { ev('sale', null, null, Math.round((Date.now() - t0) / 1000) + 's'); enviar(true); });
  setInterval(function () { enviar(); }, 15000);
  // 13 oct (noche): pantalla de entrada, deslizadas, puntos y super descuento
  window.__navMapaEv = function (t, d) { ev(t, null, null, d); };
  setTimeout(function () { if (document.getElementById('entrada')) ev('entrada_ver', null, null, ''); }, 1200);
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest && e.target.closest('#entrada .si,#entrada .no,#puntosNav .mu,#ganaste button');
    if (!t) return;
    var tipo = t.matches('#entrada .si') ? 'entrar_sonido' : t.matches('#entrada .no') ? 'entrar_mudo' : t.matches('#ganaste button') ? 'super_cerrar' : 'sonido_boton';
    ev(tipo, null, null, Math.round((Date.now() - t0) / 1000) + 's');
    if (tipo.indexOf('entrar') === 0) enviar();
  }, true);
  var arr = null;
  document.addEventListener('pointerdown', function (e) {
    if (!e.target || !e.target.closest || !e.target.closest('#vista')) { arr = null; return; }
    arr = { x: e.clientX, y: e.clientY, t: Date.now(), p: aMundo(e.clientX, e.clientY), mov: false };
  }, true);
  document.addEventListener('pointermove', function (e) {
    if (arr && !arr.mov && Math.abs(e.clientX - arr.x) + Math.abs(e.clientY - arr.y) > 25) arr.mov = true;
  }, true);
  document.addEventListener('pointerup', function (e) {
    if (arr && arr.mov) { ev('desliza', arr.p && arr.p.x, arr.p && arr.p.y, Math.round(e.clientX - arr.x) + ',' + Math.round(e.clientY - arr.y) + ' ' + (Date.now() - arr.t) + 'ms'); }
    arr = null;
  }, true);
  document.addEventListener('visibilitychange', function () {
    if (document.hidden && document.getElementById('entrada')) ev('sale_sin_entrar', null, null, Math.round((Date.now() - t0) / 1000) + 's');
  }, true);
})();
